module.exports = __webpack_public_path__ + "img/contact_us.90576d31.svg";